export const convertSlugToLowerCase = (slug) => {
  if (slugHasUpperCase(slug)) return slug.toLowerCase()
  return slug;
}

export const slugHasUpperCase = (slug) => {
  return (/[A-Z]/).test(slug)
}